import { create } from 'zustand';

const useDiscountCouponCodeStore = create((set) => ({
  discountCouponCode: {},

  setDiscountCouponCode: (newCode) => set({ discountCouponCode: newCode }),

  clearDiscountCouponCode: () => set({ discountCouponCode: {} }),
}));

export default useDiscountCouponCodeStore;
